module.exports = __webpack_public_path__ + "media/assets/stores/amazon-b0d8088f131a1d18f58f122a27022420.png";